import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  text-align: ${({ $contentAlignment }) => $contentAlignment || 'left'};
`;

export const Heading = styled.h2`
  color: ${({ $textColor }) =>
    $textColor
      ? themeGet(`colors.${$textColor}`)
      : themeGet('colors.main-text')};
  span {
    font-weight: inherit;
    font-size: inherit;
    color: inherit;
  }
`;

export const Subheading = styled.p`
  margin: 1.5rem auto;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: ${({ $textColor }) =>
    $textColor
      ? themeGet(`colors.${$textColor}`)
      : themeGet('colors.main-text')};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 1.8125rem;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    align-items: unset;
    column-gap: 1.8125rem;

    > div {
      width: calc((100% / ${({ columnCount }) => columnCount}));
    }
  }
`;

export const Disclaimer = styled.p`
  color: ${({ $textColor }) =>
    $textColor
      ? themeGet(`colors.${$textColor}`)
      : themeGet('colors.main-text')};
  font-size: 1.25rem;
  margin-top: 2rem;
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 1.25rem;
  }
`;
